<template>
    <div class="cart_order_table_box">
        <!-- 标题行 -->
        <div>
            <!-- 返回购物车 -->
            <el-button
                type="text"
                @click="$router.push('/center/cart')"
                class="cart_order_table_back">
                <span>{{$t("message.cart.backBtn")}}</span>
                <i class="el-icon-arrow-right"></i>
            </el-button>
            <!-- 标题 -->
            <div class="cart_order_table_title">{{$t("message.cart.ordertitle2")}}</div>
        </div>
        <!-- 表格 -->
        <el-table
            :data="cart_order"
            ref="cartOrderTable"
            tooltip-effect="dark"
            height="400">
            <!-- 商品名称 -->
            <el-table-column
                :label="$t('message.cart.table1')"
                align="center"
                width="300"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div class="cart_order_goods">
                        <!-- 图片 -->
                        <router-link
                            :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }"
                            class="cart_order_goods_img">
                            <img :src="row.goods_images[0]" alt="">
                        </router-link>
                        <!-- 图片 -->
                        <router-link
                            :to="{
                                name: 'pdetail',
                                query: {
                                    id: row.goods_id
                                },
                                params: {
                                    cate_id: row.cat_id
                                }
                            }">
                            <span>{{row.goods_name}}</span>
                        </router-link>
                    </div>
                </template>
            </el-table-column>
            <!-- 单价 -->
            <el-table-column
                :label="$t('message.cart.table2')"
                align="center"
                show-overflow-tooltip
                v-if="powerPrice">
                <template v-slot="{ row }">
                    <div>
                        <span>{{currency}}</span>
                        <span class="cart_order_table_price">{{row.goods_price}}</span>
                    </div>
                </template>
            </el-table-column>
            <!-- 数量 -->
            <el-table-column
                :label="$t('message.cart.table3')"
                prop="goods_number"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 合计 -->
            <el-table-column
                :label="$t('message.cart.table4')"
                align="center"
                show-overflow-tooltip
                v-if="powerPrice">
                <template v-slot="{ row }">
                    <div>
                        <span>{{currency}}</span>
                        <span class="cart_order_table_price">{{countPrice(row.goods_price, row.goods_number)}}</span>
                    </div>
                </template>
            </el-table-column>
            <!-- 类型 -->
            <el-table-column
                :label="$t('message.cart.table5')"
                prop="attr_value"
                align="center"
                show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!-- 合计 -->
        <div class="cart_order_table_total_box">
            <!-- 标题列 -->
            <ul class="cart_order_table_total_list">
                <li>{{$t("message.cart.total4")}}</li>
                <li>{{$t("message.cart.total5")}}</li>
                <li v-if="powerPrice">{{$t("message.cart.total6")}}</li>
                <!-- <li>{{$t("message.cart.total7")}}</li> -->
            </ul>
            <!-- 参数列 -->
            <ul class="cart_order_table_total_list">
                <li>
                    <span class="cart_order_table_total_num">{{totalMsg.num}}</span>
                    <span>{{$t("message.cart.total8")}}</span>
                </li>
                <li>
                    <span>{{currency}}</span>
                    <span class="cart_order_table_total_price">{{0}}</span>
                </li>
                <li v-if="powerPrice">
                    <span>{{currency}}</span>
                    <span class="cart_order_table_total_price"
                    v-if="powerPrice">{{totalMsg.price}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState({
            currency: state => state.currency,
            cart_order: state => state.order.cart_order
        }),
        ...mapGetters([
            'powerPrice',
        ]),
        totalMsg(){
            let num = 0, price = 0;
            for(let item of this.cart_order){
                price += Number(item.goods_number) * Number(item.goods_price);
                num += Number(item.goods_number);
            }
            return {
                price: price.toFixed(2),
                num
            };
        }
    },
    methods: {
        countPrice(unit, num){
            return  (Number(unit) * Number(num)).toFixed(2);
        }
    },
}
</script>

<style scoped>
.cart_order_table_back{
    float: right;
}
/* 标题 */
.cart_order_table_title{
    padding: 12px 0;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #E4E7ED;
}

/* 商品参数盒子 */
.cart_order_goods{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
}
/* 商品图片 */
.cart_order_goods_img{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 50px;
    height: 50px;
    margin-right: 5px;
}
.cart_order_goods_img>img{
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.cart_order_table_price{
    margin-left: 5px;
    color: #ff6700;
}

/* 统计部分 */
.cart_order_table_total_box{
    margin-bottom: 15px;
    padding: 15px 0;
    text-align: right;
    border-bottom: 1px solid #E4E7ED;
}
/* 统计列表 */
.cart_order_table_total_list{
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    text-align: right;
}
.cart_order_table_total_list>li{
    margin-bottom: 10px;
}
/* 数量 */
.cart_order_table_total_num{
    margin-right: 5px;
    color: #ff6700;
    font-weight: bold;
}
/* 价格 */
.cart_order_table_total_price{
    margin-left: 5px;
    font-size: 16px;
    font-weight: bold;
    color: #ff6700;
}
</style>
